import React from 'react';
import PropTypes, { number } from 'prop-types';
import { compose } from 'redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { Form as FinalForm } from 'react-final-form';
import clsx from 'clsx';
import * as validators from '../../util/validators';
import {
  Form,
  PrimaryButton,
  FieldTextInput,
  FieldSelect,
  FieldPhoneNumber,
  FieldCheckbox
} from '../../components';
import config from '../../config'

import css from './SignupForm.module.css';

const KEY_CODE_ENTER = 13;

const SignupFormComponent = props => (
  <FinalForm
    {...props}
    //initialValues={{ hide: true, marketingEmailOption: true }}
    render={fieldRenderProps => {
      const {
        rootClassName,
        className,
        formId,
        handleSubmit,
        inProgress,
        userType,
        invalid,
        intl,
        onOpenTermsOfService,
        values,
        marketingEmailOption
      } = fieldRenderProps;
      // email
      const emailLabel = intl.formatMessage({
        id: 'SignupForm.emailLabel',
      });
      const emailPlaceholder = intl.formatMessage({
        id: 'SignupForm.emailPlaceholder',
      });
      const emailRequiredMessage = intl.formatMessage({
        id: 'SignupForm.emailRequired',
      });
      const emailRequired = validators.required(emailRequiredMessage);
      const emailInvalidMessage = intl.formatMessage({
        id: 'SignupForm.emailInvalid',
      });
      const emailValid = validators.emailFormatValid(emailInvalidMessage);

      // email
      const phoneLabel = intl.formatMessage({
        id: 'SignupForm.phoneLabel',
      });
      const phonePlaceholder = intl.formatMessage({
        id: 'SignupForm.phonePlaceholder',
      });
      const phoneRequiredMessage = intl.formatMessage({
        id: 'SignupForm.phoneRequired',
      });
      const phoneRequired = validators.required(phoneRequiredMessage);
      const phoneInvalidMessage = intl.formatMessage({
        id: 'SignupForm.phoneInvalid',
      });
      const phoneValid = validators.phoneFormatValid(phoneInvalidMessage);

      // password
      const passwordLabel = intl.formatMessage({
        id: 'SignupForm.passwordLabel',
      });
      const passwordPlaceholder = intl.formatMessage({
        id: 'SignupForm.passwordPlaceholder',
      });
      const passwordRequiredMessage = intl.formatMessage({
        id: 'SignupForm.passwordRequired',
      });
      const passwordMinLengthMessage = intl.formatMessage(
        {
          id: 'SignupForm.passwordTooShort',
        },
        {
          minLength: validators.PASSWORD_MIN_LENGTH,
        }
      );
      const passwordMaxLengthMessage = intl.formatMessage(
        {
          id: 'SignupForm.passwordTooLong',
        },
        {
          maxLength: validators.PASSWORD_MAX_LENGTH,
        }
      );
      const passwordMinLength = validators.minLength(
        passwordMinLengthMessage,
        validators.PASSWORD_MIN_LENGTH
      );
      const passwordMaxLength = validators.maxLength(
        passwordMaxLengthMessage,
        validators.PASSWORD_MAX_LENGTH
      );
      const passwordRequired = validators.requiredStringNoTrim(passwordRequiredMessage);
      const passwordValidators = validators.composeValidators(
        passwordRequired,
        passwordMinLength,
        passwordMaxLength
      );

      // firstName
      const firstNameLabel = intl.formatMessage({
        id: 'SignupForm.firstNameLabel',
      });
      const firstNamePlaceholder = intl.formatMessage({
        id: 'SignupForm.firstNamePlaceholder',
      });
      const firstNameRequiredMessage = intl.formatMessage({
        id: 'SignupForm.firstNameRequired',
      });
      const firstNameRequired = validators.required(firstNameRequiredMessage);

      // lastName
      const lastNameLabel = intl.formatMessage({
        id: 'SignupForm.lastNameLabel',
      });
      const lastNamePlaceholder = intl.formatMessage({
        id: 'SignupForm.lastNamePlaceholder',
      });
      const lastNameRequiredMessage = intl.formatMessage({
        id: 'SignupForm.lastNameRequired',
      });
      const lastNameRequired = validators.required(lastNameRequiredMessage);

      // companyName
      const companyNameLabel = intl.formatMessage({
        id: 'SignupForm.companyNameLabel',
      });
      const companyNamePlaceholder = intl.formatMessage({
        id: 'SignupForm.companyNamePlaceholder',
      });
      const companyNameRequiredMessage = intl.formatMessage({
        id: 'SignupForm.companyNameRequired',
      });
      const companyNameRequired = validators.required(companyNameRequiredMessage);

      // Affiliate company name 
      const affiliateCompanyNameLabel = intl.formatMessage({
        id: 'SignupForm.affiliateCompanyNameLabel',
      });
      const affiliateCompanyNamePlaceholder = intl.formatMessage({
        id: 'SignupForm.affiliateCompanyNamePlaceholder',
      });

      const affiliateCompanyNameRequiredMessage = intl.formatMessage({
        id: 'SignupForm.affiliateCompanyNameRequired',
      });
      const affiliateCompanyNameRequired = validators.affiliateCompanyName(affiliateCompanyNameRequiredMessage);
      
      const affiliateLinkHelperLabel = intl.formatMessage({
        id: 'SignupForm.affiliateLinkHelperLabel',
      });

      // userType
      const userTypeLabel = intl.formatMessage({
        id: 'SignupForm.userTypeLabel',
      });
      const userTypePlaceholder = intl.formatMessage({
        id: 'SignupForm.userTypePlaceholder',
      });
      const userTypeRequiredMessage = intl.formatMessage({
        id: 'SignupForm.userTypeRequired',
      });
      const userTypeRequired = validators.validUserType(userTypeRequiredMessage);
      const userType1 = intl.formatMessage({
        id: 'SignupForm.userType1',
      });
      const userType2 = intl.formatMessage({
        id: 'SignupForm.userType2',
      });
      const userType3 = intl.formatMessage({
        id: 'SignupForm.userType3',
      });

      const userTypeHelpTextTO = intl.formatMessage({
        id: 'SignupForm.userTypeHelpTextTO',
      });
      const userTypeHelpTextSA = intl.formatMessage({
        id: 'SignupForm.userTypeHelpTextSA',
      });
      const userTypeHelpTextTourist = intl.formatMessage({
        id: 'SignupForm.userTypeHelpTextTourist',
      });
      // Marketing email opt-in label
      const marketingEmailOptionLabel = intl.formatMessage({
        id: 'SignupForm.marketingEmailOptionLabel',
      });

      const classes = clsx(rootClassName || css.root, className);
      const submitInProgress = inProgress;
      const submitDisabled = invalid || submitInProgress;

      const affiliateURL = config.canonicalRootURL+config.affiliateURLParam
      // No longer used as Tapfiliate now generates random links.
      // this code will commented and left for future reference

      // let affiliateCompanyname = values.cname ? values.cname.normalize("NFD")
      // .replace(/\p{Diacritic}/gu, "") // replaces accent chars with their non accented char  [ ááñ ] -> [ aan ] 
      // .replace(/\s/g, '')     // remove spaces
      // .replace(/\p{P}/gu, "") // remove punctuation
      // .replace(/\p{S}/gu, "") // remove symbols
      // .replace(/[ºª]/gu, "")  // remove special char
      // .replace(/[^a-z\d\s]+/gi,'') // removes non latin chars
      // .toLowerCase() : ''

      //let affiliateLink = affiliateURL + affiliateCompanyname 
      const affiliateLink = `${affiliateURL}aiuqiw`;

      const helptextSignUp = () =>{
        if (fieldRenderProps.values.type === '1' ) {
          return userTypeHelpTextTourist
        } else if (fieldRenderProps.values.type === '2' ) {
          return userTypeHelpTextTO
        } else if (fieldRenderProps.values.type === '3' ) {
          return userTypeHelpTextSA
        } 
        else {
              return '';
        }
      } 

      const handleTermsKeyUp = e => {
        // Allow click action with keyboard like with normal links  
        if (e.keyCode === KEY_CODE_ENTER) {
          onOpenTermsOfService();
        }
      };
      const termsLink = (
        <span
          className={css.termsLink}
          onClick={onOpenTermsOfService}
          role="button"
          tabIndex="0"
          onKeyUp={handleTermsKeyUp}
        >
          <FormattedMessage id="SignupForm.termsAndConditionsLinkText" />
        </span>
      );

      if (fieldRenderProps.values.type === '2' || fieldRenderProps.values.type === '3' ) {
        fieldRenderProps.values.hide = true;
      } else {
        fieldRenderProps.values.hide = false;
      }

      return (
        <Form className={classes} onSubmit={handleSubmit}>
          <div>
            <FieldSelect
              id={formId ? `${formId}.type` : 'type'}
              name="type"
              label={userTypeLabel}
              placeholder={userTypePlaceholder}
              validate={userTypeRequired}
              defaultValue={userType}
            >
              <option value="">{userTypePlaceholder}</option>
              <option value="1">{userType1}</option>
              <option value="2">{userType2}</option>
              <option value="3">{userType3}</option>
            </FieldSelect>
            <p className={css.helpText}>{helptextSignUp()}</p> 
            <div className={css.name}>
              <FieldTextInput
                className={css.firstNameRoot}
                type="text"
                id={formId ? `${formId}.fname` : 'fname'}
                name="fname"
                autoComplete="given-name"
                label={firstNameLabel}
                placeholder={firstNamePlaceholder}
                validate={firstNameRequired}
              />
              <FieldTextInput
                className={css.lastNameRoot}
                type="text"
                id={formId ? `${formId}.lname` : 'lname'}
                name="lname"
                autoComplete="family-name"
                label={lastNameLabel}
                placeholder={lastNamePlaceholder}
                validate={lastNameRequired}
              />
            </div>
            {(fieldRenderProps.values.hide && fieldRenderProps.values.type === '2') && (
              <FieldTextInput
                className={css.other}
                type="text"
                id={formId ? `${formId}.cname` : 'cname'}
                name="cname"
                label={companyNameLabel}
                placeholder={companyNamePlaceholder}
                validate={companyNameRequired}
              />
            )}
            {/* Affiliate company name */}
            {(fieldRenderProps.values.hide && fieldRenderProps.values.type === '3' )&& (
              <div className={css.affiliateCompanyNameWrapper}>
                
                <FieldTextInput
                  className={css.other}
                  type="text"
                  id={formId ? `${formId}.cname` : 'cname'}
                  name="cname"
                  label={affiliateCompanyNameLabel}
                  placeholder={affiliateCompanyNamePlaceholder}
                  validate={affiliateCompanyNameRequired}
                />
                <label className={css.affiliateCompanyNameLabel}>{affiliateLinkHelperLabel}</label>
                <p className={css.affiliateLink}>{affiliateLink}</p> 
              
              </div>
            )}
            <FieldPhoneNumber
              className={css.other}
              country="pt"
              specialLabel={null}
              id={formId ? `${formId}.phoneNumber` : 'phoneNumber'}
              name="phoneNumber"
              label={phoneLabel}
              type={'input'}
              placeholder={phonePlaceholder}
              validate={validators.composeValidators(phoneRequired, phoneValid)}
            />
            <FieldTextInput
              className={css.other}
              type="email"
              id={formId ? `${formId}.email` : 'email'}
              name="email"
              autoComplete="email"
              label={emailLabel}
              placeholder={emailPlaceholder}
              validate={validators.composeValidators(emailRequired, emailValid)}
            />
            <div  className={css.other}>
              <FieldCheckbox
                type="checkbox"
                id={formId ? `${formId}.MarketingEmailOption` : 'MarketingEmailOption'}
                name="marketingEmailOption"
                label={marketingEmailOptionLabel}
                value={marketingEmailOption}
              /> 
            </div>
            <FieldTextInput
              className={css.password}
              type="password"
              id={formId ? `${formId}.password` : 'password'}
              name="password"
              autoComplete="new-password"
              label={passwordLabel}
              placeholder={passwordPlaceholder}
              validate={passwordValidators}
            />
          </div>

          <div className={css.bottomWrapper}>
            <p className={css.bottomWrapperText}>
              <span className={css.termsText}>
                <FormattedMessage
                  id="SignupForm.termsAndConditionsAcceptText"
                  values={{ termsLink }}
                />
              </span>
            </p>
            <PrimaryButton type="submit" inProgress={submitInProgress} disabled={submitDisabled}>
              <FormattedMessage id="SignupForm.signUp" />
            </PrimaryButton>
          </div>
        </Form>
      );
    }}
  />
);

SignupFormComponent.defaultProps = { 
  inProgress: false,
  userType: 0,
};

const { bool, func } = PropTypes;

SignupFormComponent.propTypes = {
  inProgress: bool,
  userType: PropTypes.string,

  onOpenTermsOfService: func.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const SignupForm = compose(injectIntl)(SignupFormComponent);
SignupForm.displayName = 'SignupForm';

export default SignupForm;
